import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { RadBox } from '../common/RadBox'
import './FancyListHeader.scss'
import { RadGrid } from '../common/RadGrid'

export function FancyListHeader ({ title, description, count, actions }) {
  return (
    <RadSpaceBetween direction='vertical' size='s'>
      <RadGrid
        gridDefinition={[
          { colspan: 8 },
          { colspan: 4 }
        ]}
      >
        <RadSpaceBetween direction='horizontal' size='xxs' alignItems='end'>
          <h1>{title}</h1>
          <RadBox className='fancy-list-counter'>({count})</RadBox>
        </RadSpaceBetween>
        <RadBox float='right'>{actions}</RadBox>
      </RadGrid>
      <RadBox className='fancy-list-description'>{description}</RadBox>
    </RadSpaceBetween>
  )
}
